<template>
    <div id="employee-benefit-details">
        <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="showCoverage(0)">View Principal Benefits</button>
        <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="showCoverage(1)">View Spouse Benefit</button>
        <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="showCoverage(2)">View Dependent Benefit</button>
        <table class="table mb-0">
            <colgroup>
                <col>
                <col width="220">
                <col v-if="value.spouseBenefit" width="220">
                <col v-if="value.dependentBenefit" width="220">
            </colgroup>
            <thead>
                <tr class="text-right">
                    <th></th>
                    <th>
                        Benefit Type - {{value.benefitType}}
                    </th>
                    <th v-if="value.spouseBenefit">
                        Benefit Type - Spouse
                    </th>
                    <th v-if="value.dependentBenefit">
                        Benefit Type - Dependent
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><b>Annual Aggregated Usage (RM)</b></td>
                    <td class="text-right">
                        {{value.companyAnnualUsage.toFixed(2)}}
                    </td>
                    <td v-if="value.spouseBenefit" class="text-right">
                        {{value.spouseAnnualUsage.toFixed(2)}}
                    </td>
                    <td v-if="value.dependentBenefit" class="text-right">
                        {{value.dependentAnnualUsage.toFixed(2)}}
                    </td>
                </tr>
                <tr>
                    <td><b>Current Annual Balance (RM)</b></td>
                    <td :class="['text-right', {
                        'text-success': value.companyAnnualUsagePercentage<=30,
                        'text-warning': value.companyAnnualUsagePercentage>30 && value.companyAnnualUsagePercentage<=70,
                        'text-danger': value.companyAnnualUsagePercentage>70
                    }]"><b>
                        {{(value.companyAnnualLimit - value.companyAnnualUsage).toFixed(2)}}
                    </b></td>
                    <td v-if="value.spouseBenefit" :class="['text-right', {
                        'text-success': value.spouseAnnualUsagePercentage<=30,
                        'text-warning': value.spouseAnnualUsagePercentage>30 && value.spouseAnnualUsagePercentage<=70,
                        'text-danger': value.spouseAnnualUsagePercentage>70
                    }]"><b>
                        {{(value.spouseAnnualLimit - value.spouseAnnualUsage).toFixed(2)}}
                    </b></td>
                    <td v-if="value.dependentBenefit" :class="['text-right', {
                        'text-success': value.dependentAnnualUsagePercentage<=30,
                        'text-warning': value.dependentAnnualUsagePercentage>30 && value.dependentAnnualUsagePercentage<=70,
                        'text-danger': value.dependentAnnualUsagePercentage>70
                    }]"><b>
                        {{(value.dependentAnnualLimit - value.dependentAnnualUsage).toFixed(2)}}
                    </b></td>
                </tr>
                <tr>
                    <td><b>Total Annual Allowance (RM)</b></td>
                    <td class="text-right">
                        {{value.companyAnnualLimit.toFixed(2)}}
                    </td>
                    <td v-if="value.spouseBenefit" class="text-right">
                        {{value.spouseAnnualLimit.toFixed(2)}}
                    </td>
                    <td v-if="value.dependentBenefit" class="text-right">
                        {{value.dependentAnnualLimit.toFixed(2)}}
                    </td>
                </tr>
                <template v-if="value.companyMonthlyLimit > 0">
                    <tr>
                        <td><b>Monthly Aggregated Usage (RM)</b></td>
                        <td class="text-right">
                            {{value.companyMonthlyUsage.toFixed(2)}}
                        </td>
                        <td v-if="value.spouseBenefit" class="text-right">
                            {{value.spouseMonthlyUsage.toFixed(2)}}
                        </td>
                        <td v-if="value.dependentBenefit" class="text-right">
                            {{value.dependentMonthlyUsage.toFixed(2)}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Current Monthly Balance (RM)</b></td>
                        <td :class="['text-right', {
                            'text-success': value.companyMonthlyUsagePercentage<=30,
                            'text-warning': value.companyMonthlyUsagePercentage>30 && value.companyMonthlyUsagePercentage<=70,
                            'text-danger': value.companyMonthlyUsagePercentage>70
                        }]"><b>
                            {{(value.companyMonthlyLimit - value.companyMonthlyUsage).toFixed(2)}}
                        </b></td>
                        <td v-if="value.spouseBenefit" :class="['text-right', {
                            'text-success': value.spouseMonthlyUsagePercentage<=30,
                            'text-warning': value.spouseMonthlyUsagePercentage>30 && value.spouseMonthlyUsagePercentage<=70,
                            'text-danger': value.spouseMonthlyUsagePercentage>70
                        }]"><b>
                            {{(value.companyMonthlyLimit - value.spouseMonthlyUsage).toFixed(2)}}
                        </b></td>
                        <td v-if="value.dependentBenefit" :class="['text-right', {
                            'text-success': value.dependentMonthlyUsagePercentage<=30,
                            'text-warning': value.dependentMonthlyUsagePercentage>30 && value.dependentMonthlyUsagePercentage<=70,
                            'text-danger': value.dependentMonthlyUsagePercentage>70
                        }]"><b>
                            {{(value.companyMonthlyLimit - value.dependentMonthlyUsage).toFixed(2)}}
                        </b></td>
                    </tr>
                    <tr>
                        <td><b>Total Monthly Allowance (RM)</b></td>
                        <td class="text-right">
                            {{value.companyMonthlyLimit.toFixed(2)}}
                        </td>
                        <td v-if="value.spouseBenefit" class="text-right">
                            {{value.companyMonthlyLimit.toFixed(2)}}
                        </td>
                        <td v-if="dependentBenefit" class="text-right">
                            {{value.companyMonthlyLimit.toFixed(2)}}
                        </td>
                    </tr>
                </template>
                <template v-if="value.companyWeeklyLimit > 0">
                    <tr>
                        <td><b>Weekly Aggregated Usage (RM)</b></td>
                        <td class="text-right">
                            {{value.companyWeeklyUsage.toFixed(2)}}
                        </td>
                        <td v-if="value.spouseBenefit" class="text-right">
                            {{value.spouseWeeklyUsage.toFixed(2)}}
                        </td>
                        <td v-if="dependentBenefit" class="text-right">
                            {{value.dependentWeeklyUsage.toFixed(2)}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Current Weekly Balance (RM)</b></td>
                        <td :class="['text-right', {
                            'text-success': value.companyWeeklyUsagePercentage<=30,
                            'text-warning': value.companyWeeklyUsagePercentage>30 && value.companyWeeklyUsagePercentage<=70,
                            'text-danger': value.companyWeeklyUsagePercentage>70
                        }]"><b>
                            {{(value.companyWeeklyLimit - value.companyWeeklyUsage).toFixed(2)}}
                        </b></td>
                        <td v-if="value.spouseBenefit" :class="['text-right', {
                            'text-success': value.spouseWeeklyUsagePercentage<=30,
                            'text-warning': value.spouseWeeklyUsagePercentage>30 && value.spouseWeeklyUsagePercentage<=70,
                            'text-danger': value.spouseWeeklyUsagePercentage>70
                        }]"><b>
                            {{(value.companyWeeklyLimit - value.spouseWeeklyUsage).toFixed(2)}}
                        </b></td>
                        <td v-if="value.dependentBenefit" :class="['text-right', {
                            'text-success': value.dependentWeeklyUsagePercentage<=30,
                            'text-warning': value.dependentWeeklyUsagePercentage>30 && value.dependentWeeklyUsagePercentage<=70,
                            'text-danger': value.dependentWeeklyUsagePercentage>70
                        }]"><b>
                            {{(value.companyWeeklyLimit - value.dependentWeeklyUsage).toFixed(2)}}
                        </b></td>
                    </tr>
                    <tr>
                        <td><b>Total Weekly Allowance (RM)</b></td>
                        <td class="text-right">
                            {{value.companyWeeklyLimit.toFixed(2)}}
                        </td>
                        <td v-if="value.spouseBenefit" class="text-right">
                            {{value.companyWeeklyLimit.toFixed(2)}}
                        </td>
                        <td v-if="value.dependentBenefit" class="text-right">
                            {{value.companyWeeklyLimit.toFixed(2)}}
                        </td>
                    </tr>
                </template>
                <tr v-if="value.transactionLimit.teleconsultationApplicable">
                    <td><b>Tele-consultation Transaction Limit</b></td>
                    <td class="text-right">
                        {{value.transactionLimit.teleconsultation}}
                    </td>
                </tr>
                <tr v-if="value.transactionLimit.medicineApplicable">
                    <td><b>Medicine Transaction Limit (Telehealth Only)</b></td>
                    <td class="text-right">
                        {{value.transactionLimit.medicine}}
                    </td>
                </tr>
                <tr v-if="value.transactionLimit.clinicApplicable">
                    <td><b>Combined Limit for Clinic Consultation and Clinic Medicine</b></td>
                    <td class="text-right">
                        {{value.transactionLimit.clinic}}
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- #region Pop Ups -->
        <!-- Principal Coverage -->
        <popup-modal ref="popupModalPrincipalCoverage" :hasCloseButton="true" :title="'Principal Employee Benefits'">
            <template slot="content">
                <permissible v-model="value.pbc" :viewOnly="true" :uniqueIdentifier="1"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-secondary" type="button" @click="cancelCoverage (0)">Cancel</button>
                </div>
            </template>
        </popup-modal>

        <!-- Spouse Coverage -->
        <popup-modal ref="popupModalSpouseCoverage" :hasCloseButton="true" :title="'Spouse Benefits'">
            <template slot="content">
                <permissible v-model="value.sbc" :viewOnly="true" :uniqueIdentifier="2"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-secondary" type="button" @click="cancelCoverage (1)">Cancel</button>
                </div>
            </template>
        </popup-modal>

        <!-- Dependent Coverage -->
        <popup-modal ref="popupModalDependentCoverage" :hasCloseButton="true" :title="'Dependent Benefits'">
            <template slot="content">
                <permissible v-model="value.dbc" :viewOnly="true" :uniqueIdentifier="3"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-secondary" type="button" @click="cancelCoverage (2)">Cancel</button>
                </div>
            </template>
        </popup-modal>
        <!--#endregion -->
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import permissible from '@/components/permissible';
export default {
    'name': 'EmployeeBenefitDetails',
    'components': {
        popupModal,
        permissible
    },
    'props': {
        'value': {
            'required': true
        }
    },
    // 'data': function () {
    //     return {
    //         'apiPath': apiPath
    //     };
    // },
    'methods': {
        showCoverage (relationshipType) {
            switch (relationshipType) {
            case 0:
                this.$refs.popupModalPrincipalCoverage.show();
                break;
            case 1:
                this.$refs.popupModalSpouseCoverage.show();
                break;
            case 2:
                this.$refs.popupModalDependentCoverage.show();
                break;
            }
        },
        cancelCoverage (relationshipType) {
            switch (relationshipType) {
            case 0:
                this.$refs.popupModalPrincipalCoverage.hide();
                break;
            case 1:
                this.$refs.popupModalSpouseCoverage.hide();
                break;
            case 2:
                this.$refs.popupModalDependentCoverage.hide();
                break;
            }
        }
    }
};

</script>

<style>

</style>
